import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TableBarIcon(props: IconProps) {
    return <Icon {...props} iconKey={"table_bar"}/>
}
